import React, { FC } from 'react'
import { LinkButton } from '@/atoms/Button'
import { FlexColumn } from '@/atoms/FlexContainers'
import { ParagraphLG } from '@/atoms/Text'
import { Translate, useTranslate } from '@/utils/translate/translate-client'

export const ProjectPIFThankYou: FC<{ projectName: string }> = ({ projectName }) => {
  const { t } = useTranslate('pif')

  return (
    <>
      <Translate t={t} i18nKey="thankYouForPayingItForwardToOurProjectV4" values={{ projectName }}>
        <ParagraphLG className="my-4">
          Experience our exclusive thank you gift, featuring two special scenes just for you!
        </ParagraphLG>
      </Translate>
      <FlexColumn className="mb-10 gap-2">
        <LinkButton target="_blank" href="/m/cabrini-exclusive-scene" variant="black" outline>
          {t('exclusiveScene1', 'Exclusive Scene #1')}
        </LinkButton>
        <LinkButton target="_blank" href="/m/cabrini-exclusive-scene/gift" variant="black" outline>
          {t('exclusiveScene2', 'Exclusive Scene #2')}
        </LinkButton>
      </FlexColumn>
    </>
  )
}
